module.exports = __webpack_public_path__ + "static/media/ana_maria_pereira.56e59b1d.jpg";